import { defineComponent } from 'vue';
import { BFormTextarea } from 'bootstrap-vue';
import { Field, ErrorMessage } from 'vee-validate/compat';
import Validator from '@common/veeValidate/Validator';
import validation from '@common/mixins/validation';
import translator from '~/zf/frontend/common/mixins/translator';
export default defineComponent({
    name: 'Reason',
    compatConfig: {
        MODE: 3,
    },
    components: {
        BFormTextarea,
        Field,
        ErrorMessage,
    },
    mixins: [translator, validation],
    props: {
        alarmType: {
            type: String,
        },
        alarmId: {
            type: Number,
        },
        modelValue: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            Validator,
        };
    },
    computed: {
        placeholder() {
            if (!this.alarmType || !this.alarmId) {
                return this.tr('viiu.componentMuting.REASON_FOR_MUTING');
            }
            return `${this.alarmType}, ID ${this.alarmId}`;
        },
    },
});
